import React from 'react';
import Modal from 'react-modal';
import CreateEditCustomer from "../components/customer/CreateEditCustomer";

const CreateEditCustomerModal = (props) => {
    const {
        customerId  = null,
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => {},
        onComplete  = (customer) => {},
        onDelete    = (customer) => {},
        id          = "create-edit-customer-modal",
    } = props;

    const handleCancel = () => {
        onCancel();
    }

    const handleComplete = (customer) => {
        onComplete(customer);
    }

    const handleDelete = (customer) => {
        onDelete(customer);
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleCancel()}
            contentLabel={!!customerId ? "Edit Customer" : "Create Customer"}
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal wide-modal allow-overflow'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h4 className="modal-title text-eh-navy">{!!customerId ? "Edit Customer" : "Add Customer"}</h4>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleCancel()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <CreateEditCustomer
                        customerId={customerId}
                        onCancel={() => handleCancel()}
                        onComplete={(customer) => handleComplete(customer)}
                        onDelete={(customer) => handleDelete(customer)}
                        parentId={parentId}
                    />
                </div>
            </div>
        </Modal>
    );
}

export default CreateEditCustomerModal;
